import { Avatar, Button, IconButton, ListItemText, MenuItem, TableCell, TableRow, Tooltip } from "@mui/material";
import { IUser } from "../../../types/user";
import Label from "../../../components/label";
import Iconify from "../../../components/iconify";
import { useRouter } from "../../../routes/hooks";
import { useBoolean } from "../../../hooks/use-boolean";
import { ConfirmDialog } from "../../../components/custom-dialog";

type Props = {
    row: IUser;
    onDeleteRow: (id: number) => void;
}

const UserTableRow = ({ row, onDeleteRow }: Props) => {

    const router = useRouter();
    const confirm = useBoolean();

    return (
        <>
            <TableRow hover>

                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.id}</TableCell>

                <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar alt={row.name} sx={{ mr: 2 }} />

                    <ListItemText
                        primary={row.name}
                        secondary={row.email}
                        primaryTypographyProps={{ typography: 'body2' }}
                        secondaryTypographyProps={{
                            component: 'span',
                            color: 'text.disabled',
                        }}
                    />
                </TableCell>

                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.username}</TableCell>

                <TableCell>
                    <Label
                        variant="soft"
                        color={row.deletedAt ? 'error' : 'success'}
                    >
                        {row.deletedAt ? 'Não' : 'Sim'}
                    </Label>
                </TableCell>

                <TableCell align="right">
                    <Tooltip title="Editar" placement="top" arrow>
                        <IconButton color="default" onClick={() => router.push(`/users/${row.id}`)}>
                            <Iconify icon="solar:pen-bold" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={row.deletedAt ? 'Ativar' : 'Desativar'} placement="top" arrow>
                        <IconButton color="error" onClick={confirm.onTrue}>
                            <Iconify icon={row.deletedAt ? 'octicon:upload-16' : 'solar:trash-bin-trash-bold'} />
                        </IconButton>
                    </Tooltip>
                </TableCell>

            </TableRow>

            <ConfirmDialog
                open={confirm.value}
                onClose={confirm.onFalse}
                title={row.deletedAt ? 'Ativar' : 'Desativar' + ' Usuário'}
                content={`Você tem certeza que deseja ${row.deletedAt ? 'ativar' : 'desativar'} este usuário?`}
                action={
                    <Button variant="contained" color="error" onClick={() => onDeleteRow(row.id)}>
                        {row.deletedAt ? 'Ativar' : 'Desativar'}
                    </Button>
                }
            />
        </>
    );

}

export default UserTableRow;